import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Home } from 'lucide-react';

const FAQPage = () => {
  const handleGoBack = () => {
    window.history.back();
  };

  const handleGoHome = () => {
    window.location.href = '/';
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 p-4">
      <div className="max-w-4xl mx-auto">
        {/* 헤더 */}
        <div className="bg-white rounded-lg shadow-lg p-6 mb-6">
          <div className="flex items-center justify-between mb-4">
            <Button onClick={handleGoBack} variant="outline" className="flex items-center gap-2">
              <ArrowLeft className="w-4 h-4" />
              뒤로가기
            </Button>
            <Button onClick={handleGoHome} variant="outline" className="flex items-center gap-2">
              <Home className="w-4 h-4" />
              홈으로
            </Button>
          </div>
          <h1 className="text-3xl font-bold text-center text-blue-800 mb-2">
            보수교육·면허신고 관련 FAQ
          </h1>
          <div className="text-center text-gray-600">
            <p>KHIMA 대한보건의료정보관리사협회</p>
          </div>
        </div>

        {/* FAQ 내용 */}
        <div className="bg-white rounded-lg shadow-lg p-8">
          
          {/* 1. 교육 관련 */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-blue-700 border-b-2 border-blue-700 pb-2 mb-6">
              1. 교육 관련
            </h2>
            
            <h3 className="text-xl font-semibold text-gray-700 mb-4">가. 보수교육</h3>
            
            <div className="space-y-6">
              <div>
                <div className="font-bold text-blue-900 mb-2">Q. 보수교육은 매년 언제하나요?</div>
                <div className="ml-4 text-gray-700 leading-relaxed">
                  보수교육은 연중 상시 이수 가능합니다. 온라인 보수교육의 경우 협회 홈페이지에서 언제든지 수강 신청하실 수 있습니다.
                </div>
              </div>

              <div>
                <div className="font-bold text-blue-900 mb-2">Q. 면허 취득 후, 보수교육을 이수한 적이 없습니다. 불이익이 있나요?</div>
                <div className="ml-4 text-gray-700 leading-relaxed">
                  보수교육 이수 또는 면제(유예,비대상) 내역이 없으실 경우 면허신고 자체가 불가능합니다. 신고기간이 지났음에도 현재 면허신고는 가능하나 일정시점 이후 면허 정지처분이 내려지니 빠른 시일내에 신고하여 주시기 바랍니다.
                </div>
              </div>

              <div>
                <div className="font-bold text-blue-900 mb-2">Q. 보수교육을 반드시 이수해야 하나요?</div>
                <div className="ml-4 text-gray-700 leading-relaxed">
                  해당 연도에 보건의료정보관리사 업무를 6개월 이상 종사한 경우 보수교육을 이수해야 합니다. 단, 면제·유예·비대상 요건에 해당하는 경우 신청을 통해 보수교육을 이수하지 않을 수 있습니다.
                </div>
              </div>

              <div>
                <div className="font-bold text-blue-900 mb-2">Q. 보수교육을 매년 받아야 하나요?</div>
                <div className="ml-4 text-gray-700 leading-relaxed">
                  해당 연도에 보건의료정보관리사 업무를 6개월 이상 종사한 경우에만 보수교육을 이수해야 합니다.
                </div>
              </div>

              <div>
                <div className="font-bold text-blue-900 mb-2">Q. 보수교육을 이수하려면 협회에 입회를 해야 하나요?</div>
                <div className="ml-4 text-gray-700 leading-relaxed">
                  협회 회원 여부와 관계없이 보수교육을 이수하실 수 있습니다.
                </div>
              </div>

              <div>
                <div className="font-bold text-blue-900 mb-2">Q. 오프라인 보수교육 참석이 어려운 경우 어떻게 하나요?</div>
                <div className="ml-4 text-gray-700 leading-relaxed">
                  중앙회 학술대회나 시·도회 보수교육과 같은 오프라인 보수교육을 이수하지 못하시는 경우에는 상시로 운영 중인 온라인 보수교육을 이수하시면 됩니다.
                </div>
              </div>

              <div>
                <div className="font-bold text-blue-900 mb-2">Q. 전년도 보수교육을 이수하지 못했습니다. 어떻게 하나요?</div>
                <div className="ml-4 text-gray-700 leading-relaxed">
                  전년도에 보수교육을 이수하지 못한 경우 온라인 보수교육으로 수강하실 수 있습니다. 온라인 보수교육 수강 신청 시 평점반영년도를 선택하여 평점반영년도를 선택할 수 있으며, 미이수한 평점반영년도를 선택하여 신청하시면 해당연도로 평점이 반영됩니다.
                </div>
              </div>

              <div>
                <div className="font-bold text-blue-900 mb-2">Q. 온라인 보수교육을 어떻게 이수할 수 있나요?</div>
                <div className="ml-4 text-gray-700 leading-relaxed">
                  협회 홈페이지 로그인 후 [교육센터]-[온라인교육]에서 이수하실 수 있습니다. 자세한 교육 신청 방법은 공지사항의 '온라인 보수교육 상시과정 안내' 게시글을 참고하여 주시기 바랍니다.
                </div>
              </div>

              <div>
                <div className="font-bold text-blue-900 mb-2">Q. 온라인 보수교육 신청 시 평점반영년도 선택을 못했는데(or 잘못 적용했는데) 어떻게 하나요?</div>
                <div className="ml-4 text-gray-700 leading-relaxed">
                  평점반영년도를 선택하지 못한 경우 보수교육 결제년도로 보수교육 평점이 반영됩니다. 만약 평점 반영년도를 변경하고 싶으신 경우, 해당하는 온라인 강의 결제 일자, 평점을 반영하고자 하는 연도, 면허번호, 성함을 함께 기재하여 협회 메일(khima@khima.or.kr)로 보내주시면 5일이내에 반영될 예정이오니 참고하여 주시기 바랍니다.
                </div>
              </div>

              <div>
                <div className="font-bold text-blue-900 mb-2">Q. 온라인 보수교육으로 8평점을 모두 이수할 수 있나요?</div>
                <div className="ml-4 text-gray-700 leading-relaxed">
                  네. 온라인 보수교육의 이수평점 제한은 없으며, 원하시는 평점만큼 모두 수강하실 수 있습니다.
                </div>
              </div>

              <div>
                <div className="font-bold text-blue-900 mb-2">Q. 온라인교육센터 시스템 오류가 있는 것 같습니다. 왜 그런 걸까요?</div>
                <div className="ml-4 text-gray-700 leading-relaxed">
                  <strong>- 온라인 교육 신청 목록이 뜨지 않는 경우 or 온라인 교육 동영상 콘텐츠 목록이 뜨지 않는 경우</strong><br/>
                  온라인교육센터 접속 시, 인터넷 익스플로러 브라우저를 이용하여 접속하였을 경우 나타나는 현상입니다. 인터넷 익스플로러 브라우저의 지원이 종료됨에 따라 엣지 또는 크롬 브라우저를 이용하여 온라인교육센터를 접속하여 주시기 바랍니다.<br/>
                  온라인교육센터에 대한 이용문의 관련하여서는 [온라인교육센터]-[학습지원]-FAQ에서도 확인하실 수 있습니다.
                </div>
              </div>
            </div>

            <h3 className="text-xl font-semibold text-gray-700 mb-4 mt-8">나. 평점</h3>
            
            <div className="space-y-6">
              <div>
                <div className="font-bold text-blue-900 mb-2">Q. 보수교육 이수 평점 확인은 어디서 할 수 있나요?</div>
                <div className="ml-4 text-gray-700 leading-relaxed">
                  보수교육 이수 평점 확인은 협회 회원, 비회원 여부와 관계없이 협회 홈페이지에 로그인 하신 후, [마이페이지]내 교육이수현황에서 이수하신 평점을 확인하실 수 있으며 해당연도를 클릭하시면 이수증을 출력하실 수 있습니다.
                </div>
              </div>

              <div>
                <div className="font-bold text-blue-900 mb-2">Q. 온라인 보수교육을 이수하였는데 협회 홈페이지(or 면허신고센터)에 반영이 안되었습니다. 언제 반영되는 건가요?</div>
                <div className="ml-4 text-gray-700 leading-relaxed">
                  온라인 보수교육 이수 평점은 실시간으로 반영되는 것이 아니며, 당월에 진도율 100% 이수하신 강의에 대한 보수교육 평점은 익월 1일(공휴일인 경우 다음날) 오후 6시에 일괄 업로드 됩니다.<br/>
                  다만, 2026년 1월, 2월의 경우 면허효력정지 처분 통지로 인하여 협회 홈페이지에는 매주 월요일(공휴일인 경우 다음날) 오후 6시에 일괄 업로드되며, 면허신고센터에는 매주 화요일(공휴일인 경우 다음날) 오후 6시에 일괄 업로드되오니 참고하여 주시기 바랍니다.
                </div>
              </div>

              <div>
                <div className="font-bold text-blue-900 mb-2">Q. 온라인 보수교육 이수증(또는 수료증)이 급하게 필요합니다. 보수교육 평점을 반영하여 주실 수 있을까요?</div>
                <div className="ml-4 text-gray-700 leading-relaxed">
                  2026년 1월, 2월의 경우 면허효력정지 처분 통지로 인하여 협회 홈페이지에는 매주 월요일(공휴일인 경우 다음날) 오후 6시에 일괄 업로드되며, 면허신고센터에는 매주 화요일(공휴일인 경우 다음날) 오후 6시에 일괄 업로드 됩니다.<br/>
                  해당일 이전에 온라인 보수교육 이수증이 필요하신 경우, 면허번호 및 성함을 기재하여 협회 메일(khima@khima.or.kr)로 보수교육 평점 반영 신청을 하여 주시면 익일 오후에 확인하실 수 있습니다.
                </div>
              </div>
            </div>
          </section>

          {/* 2. 면허신고 관련 */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-blue-700 border-b-2 border-blue-700 pb-2 mb-6">
              2. 면허신고 관련
            </h2>
            
            <h3 className="text-xl font-semibold text-gray-700 mb-4">가. 면허신고 개요</h3>
            
            <div className="space-y-6">
              <div>
                <div className="font-bold text-blue-900 mb-2">Q. 면허신고는 어떻게 하나요?</div>
                <div className="ml-4 text-gray-700 leading-relaxed">
                  면허신고는 2014년도부터 전년도까지의 보수교육을 각 연도별 보수교육을 이수하거나, 연도별 보수교육 면제·유예·비대상자로 확인받은 경우에 가능합니다.<br/>
                  신고요건을 갖추신 경우 협회 홈페이지 [면허신고센터]-[면허신고 바로가기]로 접속하시어 로그인 한 후 면허신고서를 작성하여 제출하면 면허신고가 완료됩니다.
                </div>
              </div>

              <div>
                <div className="font-bold text-blue-900 mb-2">Q. 협회 비회원인데 면허신고가 가능한가요?</div>
                <div className="ml-4 text-gray-700 leading-relaxed">
                  보건의료정보관리사라면 협회 회원 여부와 관계없이 면허신고가 가능합니다.
                </div>
              </div>

              <div>
                <div className="font-bold text-blue-900 mb-2">Q. 면허신고는 언제까지 해야하나요?</div>
                <div className="ml-4 text-gray-700 leading-relaxed">
                  면허신고는 면허취득일 또는 신고일로부터 매 3년마다 해당년도 1월 1일부터 12월 31일까지 신고하여야 합니다.<br/>
                  다만, (2026년 현재 기준) 2022년도까지의 면허취득자이면서 한 번도 면허신고를 하지 않으신 경우 면허 효력정지 처분을 받으실 수 있으니 빠른 시일내에 면허신고 하시기 바랍니다.<br/>
                  (ex. 2022년도 면허취득자 → 2025년 면허신고 대상 (신고기간: 2025.01.01~2025.12.31.))
                </div>
              </div>

              <div>
                <div className="font-bold text-blue-900 mb-2">Q. 이전에 면허신고를 했는데 또 신고를 해야 하나요?</div>
                <div className="ml-4 text-gray-700 leading-relaxed">
                  네. 면허신고는 면허자 본인의 실태와 취업상황, 보수교육 이수현황 등을 면허 취득 및 신고일로부터 3년마다 한번 씩 보건복지부장관에게 신고하는 것입니다.
                </div>
              </div>

              <div>
                <div className="font-bold text-blue-900 mb-2">Q. 면허신고를 하지 않으면 어떻게 되나요?</div>
                <div className="ml-4 text-gray-700 leading-relaxed">
                  면허신고를 하지 않은 경우 의료기사 등에 관한 법률 제22조 제3항에 따라 면허신고를 할 때까지 면허 효력 정지 처분을 받을 수 있습니다. 면허 효력 정지처분 이후에는 해당 면허 관련 업무에 종사할 수 없습니다.<br/>
                  면허 효력 정지는 보건복지부에서 시행하는 것으로 면허효력 정지 전에 면허미신고자에 대해 면허효력정지 사전통지 및 의견제출 기회를 부여하며, 최종 미신고로 확인된 경우 면허효력 정지 처분이 이뤄집니다.<br/>
                  면허정지처분을 받지 않도록 면허신고를 하여 주시기 바랍니다.
                </div>
              </div>

              <div>
                <div className="font-bold text-blue-900 mb-2">Q. 보건의료정보관리사 면허를 올해(2026)에 발급받았습니다. 면허신고는 언제 해야하나요?</div>
                <div className="ml-4 text-gray-700 leading-relaxed">
                  면허신고는 최초 면허를 발급받은 해를 기준으로 3년 후부터 매 3년마다 신고하여야 합니다. 따라서, 2026년 면허발급자는 2029년 1월 1일부터 2029년 12월 31일 기간 중에 신고직전년도 2026년, 2027년, 2028년의 보수교육을 이수 또는 면제·유예·비대상 판정을 받으신 후 면허신고를 하시면 됩니다.<br/>
                  단, 신규 면허취득자는 면허를 취득한 해에는 보수교육을 면제를 받을 수 있으므로, 협회 홈페이지 [면허신고센터]-[보수교육 면제 유예 비대상 신청 안내] 페이지를 참고하셔서 면제신청하시기 바랍니다.
                </div>
              </div>

              <div>
                <div className="font-bold text-blue-900 mb-2">Q. 면허신고센터에서 면허신고 대상자가 아니라고 듣니다. 왜 그런걸까요?</div>
                <div className="ml-4 text-gray-700 leading-relaxed">
                  먼저 [협회 홈페이지] 내 '보수교육·면허신고 절차 안내 도우미'를 진행하시어 본인의 상황을 점검하여 주시기 바랍니다.<br/>
                  이후 면허신고 대상자이실 경우 면허신고 요건을 충족하지 못하여 면허신고 대상자가 아니라고 안내된 것이오니 아래의 내용을 참고하여 절차를 진행하여 주시기 바라며, 면허신고 대상자가 아닌 경우 차후 면허신고 대상 연도에 면허신고를 진행하여 주시기 바랍니다.
                </div>
              </div>

              <div className="bg-blue-50 p-4 rounded-lg">
                <div className="font-bold text-blue-900 mb-2">&lt;면허신고 대상자이실 경우&gt;</div>
                <div className="ml-4 text-gray-700 leading-relaxed space-y-2">
                  <div>
                    <strong>(해당 연도 보수교육 이수 대상자이실 경우)</strong><br/>
                    당월에 이수하신 보수교육 평점은 면허신고센터에 익월 10일(공휴일인 경우 다음날) 오후 6시에 일괄 반영되나, 2026년 1월, 2월의 경우 면허효력정지 처분 통지로 인하여 면허신고센터에는 매주 화요일(공휴일인 경우 다음날) 오후 6시에 일괄 업로드되며, 면허신고는 매주 수요일에 가능하십니다.<br/>
                    ※ 2020년도부터 보수교육 이수 대상자일 경우 이수 필요평점 중 면허신고 대상 기간 동안 합산하여 필수과목 2평점을 이수한 내역이 있어야 면허신고 가능
                  </div>
                  <div>
                    <strong>(해당 연도 보수교육 면제, 유예, 비대상자이실 경우)</strong><br/>
                    보수교육 면제, 유예, 비대상 신청은 신청일로부터 최대 5일이내에 처리되오니 신청일로부터 5일 이후에 면허신고 가능하십니다.
                  </div>
                </div>
              </div>
            </div>

            <h3 className="text-xl font-semibold text-gray-700 mb-4 mt-8">나. 면허신고서 작성 및 결과 확인</h3>
            
            <div className="space-y-6">
              <div>
                <div className="font-bold text-blue-900 mb-2">Q. 면허신고서의 내용을 수정하고 싶습니다.</div>
                <div className="ml-4 text-gray-700 leading-relaxed">
                  이미 제출하신 면허신고서의 내용은 수정이 불가합니다.
                </div>
              </div>

              <div>
                <div className="font-bold text-blue-900 mb-2">Q. 면허신고 결과는 어떻게 확인하나요?</div>
                <div className="ml-4 text-gray-700 leading-relaxed">
                  협회 홈페이지 [면허신고센터]-[면허신고 바로가기]로 접속 후 통합로그인 창에서 직종, 성명, 면허번호, 성별, 출생연도, 비밀번호를 입력한 뒤 로그인 하시면 신고결과 조회가 가능합니다.
                </div>
              </div>

              <div>
                <div className="font-bold text-blue-900 mb-2">Q. 면허신고할 때 사용한 비밀번호를 잊어버렸습니다. 확인할 수 있나요?</div>
                <div className="ml-4 text-gray-700 leading-relaxed">
                  면허신고센터 통합로그인 창에서 비밀번호를 찾으실 수 있습니다.<br/>
                  협회 홈페이지 [면허신고센터]-[면허신고 바로가기]로 접속 후 [면허(자격)신고센터 통합로그인]에서 '비밀번호 찾기'클릭 하시어 성명과 면허번호를 입력 후, 면허신고 시 등록한 휴대폰 또는 이메일로 비밀번호를 받아보실 수 있습니다.<br/>
                  확인된 비밀번호로 접속하신 후 비밀번호를 변경해서 사용하시기 바랍니다.
                </div>
              </div>

              <div>
                <div className="font-bold text-blue-900 mb-2">Q. 면허신고를 완료하였는데 신고확인서 출력은 어떻게 하나요?</div>
                <div className="ml-4 text-gray-700 leading-relaxed">
                  신고확인서 출력은 면허신고센터에서만 가능합니다.<br/>
                  [면허신고센터]-[면허신고 바로가기]로 접속 후 [면허(자격)신고센터 통합로그인]에서 로그인 후 [신고현황확인]메뉴 클릭 후 면허신고현황에서 확인서 출력 버튼을 클릭하시면 출력이 가능합니다.
                </div>
              </div>

              <div>
                <div className="font-bold text-blue-900 mb-2">Q. 보수교육 면제·유예·비대상 신청 했는데 면허 신고는 언제 할 수 있나요?</div>
                <div className="ml-4 text-gray-700 leading-relaxed">
                  [면허신고센터]-[면허신고 바로가기] 통합로그인 후 '신고현황확인'에서 결과 조회가 가능합니다.
                </div>
              </div>
            </div>

            <h3 className="text-xl font-semibold text-gray-700 mb-4 mt-8">다. 보수교육 면제·유예·비대상 신청</h3>
            
            <div className="space-y-6">
              <div>
                <div className="font-bold text-blue-900 mb-2">Q. 보수교육 면제·유예·비대상 신청은 어떻게 하나요?</div>
                <div className="ml-4 text-gray-700 leading-relaxed">
                  보수교육 면제 신청은 면제·유예·비대상 대상자에 따른 증명서류를 반드시 구비한 후 보수교육 면제·유예·비대상 신청 웹페이지에서 신청서를 작성하고 증빙서류를 첨부하셔야 합니다.<br/>
                  협회 홈페이지 [면허신고센터]-[면허신고 바로가기]에서 통합로그인 후 보수교육 면제·유예·비대상 신청이 가능합니다. 면제·유예·비대상 신청 방법 및 증빙서류 등 자세한 사항은 협회 홈페이지 [면허신고센터]-[보수교육 면제·유예·비대상 신청 안내]에서 확인하실 수 있습니다.
                </div>
              </div>

              <div>
                <div className="font-bold text-blue-900 mb-2">Q. 보수교육 면제·유예·비대상 신청 시 증빙서류는 무엇인가요?</div>
                <div className="ml-4 text-gray-700 leading-relaxed">
                  증빙서류는 협회 홈페이지 [면허신고센터]-[보수교육 면제·유예·비대상 신청 안내] 또는 협회 홈페이지 공지사항 '보수교육 면제 유예 비대상 신청 시 증빙서류 안내' 게시글에서 확인하실 수 있습니다.
                </div>
              </div>

              <div>
                <div className="font-bold text-blue-900 mb-2">Q. 협회 비회원인데 면제·유예·비대상 신청이 가능한가요?</div>
                <div className="ml-4 text-gray-700 leading-relaxed">
                  보건의료정보관리사이시면 협회 회원 여부와 관계없이 보수교육 면제 신청이 가능합니다.
                </div>
              </div>

              <div>
                <div className="font-bold text-blue-900 mb-2">Q. 올해 보수교육 면제·유예·비대상 신청은 언제 할 수 있나요?</div>
                <div className="ml-4 text-gray-700 leading-relaxed">
                  당해연도 보수교육 면제·유예·비대상 신청은 올해 7월 1일 이후부터 신청 가능하십니다.<br/>
                  (*보건의료정보관리사 업무 미종사 기간 6개월 이상 시 유예가 가능하므로 6개월이 지난 시점부터 신청가능함)
                </div>
              </div>

              <div>
                <div className="font-bold text-blue-900 mb-2">Q. 보수교육 면제 신청 결과는 언제, 어떻게 확인할 수 있나요?</div>
                <div className="ml-4 text-gray-700 leading-relaxed">
                  면제 신청결과는 면제 신청일로부터 5일 이내에 확인 가능합니다.<br/>
                  면제 신청 결과 조회는 [면허신고센터]-[면허신고 바로가기] 통합로그인 후 [신고현황확인] 페이지에서 신청결과 조회가 가능합니다.
                </div>
              </div>
            </div>
          </section>

          {/* 문의처 */}
          <section className="bg-blue-50 rounded-lg p-6 text-center">
            <h3 className="text-lg font-semibold text-blue-800 mb-3">문의처</h3>
            <div className="space-y-2 text-gray-700">
              <p><strong>KHIMA 대한보건의료정보관리사협회</strong></p>
              <p>이메일: khima@khima.or.kr</p>
              <p>홈페이지: <a href="https://www.khima.or.kr" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">https://www.khima.or.kr</a></p>
              <p>면허신고센터: <a href="https://lic.kuksiwon.or.kr" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">https://lic.kuksiwon.or.kr</a></p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default FAQPage;